import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Accordion from "../Accordion";
import QuickFilter from "../QuickFilter/QuickFilter";
import QuickFilterError from "../QuickFilterError/QuickFilterError";
import "./style.css";
import localization from "../../data/config";

const FeatureLayout = (props) => {
  const [isSticky, setIsSticky] = useState(false);
  const [selectedFiltersCount, setSelectedFiltersCount] = useState(0);
  const [isOpen, setIsOpen] = useState(true);
  const [errorArray, setErrorArray] = useState([]);
  const jsonData = useSelector( (state) => state.filters.quickFilter );
  const { isReseted } = useSelector((state) => ({
    isReseted: state.qs.isReseted,
  }));

  useEffect(() => {
    if (isReseted){
      setSelectedFiltersCount(0);
    }
  }, [isReseted])
  
  useEffect(() => {
    if (!isOpen) {
    setIsOpen(false)
    }
}, [isOpen]);

  const toggleHandler = () => {
    setIsOpen(!isOpen);
}

const handleErrorStateChange = (newState) => {
  setErrorArray(newState);
};
  return (
    <>
    {Object.keys(jsonData).length > 0 ? 
    <div className={`pst-feature ${isSticky ? "sticky" : ""}`} id="pst-feature">
      <Accordion title={localization.quickFilters} setToggle={toggleHandler} accordionOpen={isOpen} selectedFiltersCount={selectedFiltersCount}>
      {errorArray.length > 0 ?
      <QuickFilterError errorList = {errorArray} />
         : null}
          <QuickFilter mod={props.mod} setMod={props.setMod}  setToggle={toggleHandler} accordionOpen={isOpen} setSelectedFiltersCount={setSelectedFiltersCount} onErrorStateChange={handleErrorStateChange}/>
      </Accordion>
    </div>
    : null}
    </>
  );
};
export default FeatureLayout;
